/** @format */

import React, { PureComponent } from 'react';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import { connect } from 'react-redux';
import { TableCell, TableRow } from '@material-ui/core';
import ViewButton from '../../../components/Buttons/ViewButton';
import { DateHelperTs } from '../../../helpers/DateHelperTs';
import I18n from '../../../components/Translate/I18n';
import ReportHelper from '../../../helpers/ReportHelper';
import GridContainer from '../../../components/Grid/GridContainer';
import DeleteButton from '../../../components/Buttons/DeleteButton';
import i18n from 'i18next';
import { DocumentInterface } from '../../../interfaces/platform/DocumentInterface';
import { DownloadFile } from '../../../helpers/DownloadHelper';
import { documentConstants } from '../../../modules/document/actions';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { ReportInterface } from '../../../interfaces/platform/ReportInterface';
import DownloadButton from '../../../components/Buttons/DownloadButton';
import OPL_STYLE from '../../../assets/themes/OPL/OplStyle';
import oplAppStyle from '../../../assets/themes/OPL/jss/App/OplAppStyle';
import PlatformResellerInterface from "../../../interfaces/platform/PlatformResellerInterface";
import Tooltip from "@material-ui/core/Tooltip";

interface ReportListItemProps {
    dispatch: any;
    classes: any;
    item: any;
    activeRow: number | null;

    setActiveRow(id: number): void;

    openReportView: any;
    deleteCallback: any;
    platformResellerList?: Array<PlatformResellerInterface>
}

class ReportListItem extends PureComponent<ReportListItemProps> {
    viewButton = (): void => {
        //
    };

    getReportNameFromParams = (item: any): string => {
        const decodedParams = JSON.parse(item.params);

        if ('reportName' in decodedParams) {
            return decodedParams.reportName;
        } else {
            return i18n.t(item.reportType.mnemonic);
        }
    };
    private FormGeneralHelper: any;

    requestFileDownload = (document: ReportInterface, type = 'document_set'): void => {
        const newDocument: DocumentInterface = {
            '@id': document['@id'],
            downloadHash: document.hash,
            id: document.id,
            state: document.state,
            requestParams: document.params,
            file: document.file,
        };
        const itemLoader = new ItemLoaders(this.props.dispatch);
        itemLoader.getWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath(`/download_documents/${type}/${newDocument.downloadHash}`)),
            documentConstants.FILE_DOWNLOAD,
            (data: any) => {
                DownloadFile(data, newDocument);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false, dispatchErrorAfterCallback: false }
        );
    };

    render():
        | React.ReactElement<any, string | React.JSXElementConstructor<any>>
        | string
        | number
        | {}
        | React.ReactNodeArray
        | React.ReactPortal
        | boolean
        | null
        | undefined {
        const { classes, item, activeRow, setActiveRow, platformResellerList } = this.props;
        const tableCellRoot = { root: classes.tableCellRoot };
        const tableRowRoot = { root: classes.tableRowRoot };
        const tableControlStickyHeader = { root: classes.tableControlStickyHeader };

        let rowActiveColor = 'white';
        if (activeRow === item.id) {
            rowActiveColor = OPL_STYLE.TABLE.ACTIVE_ROW;
        }


        let params = JSON.parse(item.params);
        const resellers: Array<string> =[];
        if(platformResellerList) {
            params.platformResellerId.map((resellerId: number) => {
                platformResellerList.map((reseller => {
                    if(reseller.id === resellerId) {
                        resellers.push(reseller.mainname);
                    }
                }))
            })
        }

        return (
            <TableRow
                style={{ backgroundColor: rowActiveColor }}
                classes={tableRowRoot}
                hover={true}
                onClick={(): void => {
                    setActiveRow(item.id);
                }}
            >
                <TableCell style={{ backgroundColor: rowActiveColor }} align="left" classes={tableControlStickyHeader}>
                    <ViewButton callback={this.props.openReportView} callbackParam={item} />
                    {item.state === ReportHelper.reportState.COMPLETED && item.hash && (
                        <DownloadButton
                            className={classes}
                            tooltipTitle={'general:common.download'}
                            tooltipPnlacement={'bottom'}
                            callback={(data: { document: ReportInterface; type: string }): void => {
                                this.requestFileDownload(item, 'report');
                            }}
                            callbackParam={{ document: item, type: 'report' }}
                        />
                    )}
                    <DeleteButton
                        disabled={ReportHelper.canBeDeleted(item)}
                        callback={this.props.deleteCallback}
                        callbackParam={{
                            id: item.id,
                        }}
                    />
                </TableCell>
                <TableCell classes={tableCellRoot} align="left">
                    {item.id}
                </TableCell>
                <TableCell classes={tableCellRoot} align="left">
                    {resellers.length < 3 ? resellers.join(',') :
                        <Tooltip title={resellers.join(',')} classes={{ tooltip: classes.tooltip }}>
                            <p>{`${resellers[0]},${resellers[1]},+${resellers.length - 2}`}</p>
                        </Tooltip>
                    }
                </TableCell>
                <TableCell classes={tableCellRoot} align="left">
                    <GridContainer GridItemsAlignment={'center'}>
                        {ReportHelper.reportTypeArr.includes(item.reportType.id) ?  this.getReportNameFromParams(item) :  <I18n trans={item.reportType.mnemonic} />}
                    </GridContainer>
                </TableCell>
                <TableCell classes={tableCellRoot} align="left">
                    {DateHelperTs.format(item.createdOn)}
                </TableCell>
                <TableCell classes={tableCellRoot} align="left">
                    {DateHelperTs.format(item.proccessingStartedOn)}
                </TableCell>
                <TableCell classes={tableCellRoot} align="left">
                    {DateHelperTs.format(item.completedOn)}
                </TableCell>
                <TableCell classes={tableCellRoot} align="left">
                    <I18n trans={'reports:state.' + ReportHelper.getStateName(item.state)} />
                </TableCell>
                <TableCell classes={tableCellRoot} align="center">
                    {ReportHelper.renderProgress(item.state, classes)}
                </TableCell>
            </TableRow>
        );
    }
}

const mapStateToProps = (state: any): object => {
    return {};
};

export default compose<any, any>(connect(mapStateToProps), withStyles(oplAppStyle))(ReportListItem);
